// extracted by mini-css-extract-plugin
var _1 = "Na8oBcul";
var _2 = "r68dZ3bU";
export { _1 as "inputCard", _2 as "mobileSelect" }
